/**
 * Subscription Management Platform API
 * This document describes the functionality of the API belonging to the Subscription Management Platform ## Parameters ### Parameters with type \"array[string]\" or \"array[integer]\" should be given as multiple parameters with same key and different values    * param=A&param=B&param=C    * param=0&param=1&param=2
 *
 * OpenAPI spec version: 2.0.7
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */


export interface TRANSACTIONINFO {
    transactionId?: string;
    /**
     * eUICC-ID
     */
    eid?: string;
    /**
     * If empty the operation is not ICCID specific
     */
    iccid?: string;
    operation?: TRANSACTIONINFO.OperationEnum;
    state?: TRANSACTIONINFO.StateEnum;
    /**
     * Date time when the transaction was started
     */
    started?: string;
    /**
     * Date time when the transaction was finished
     */
    finished?: string;
}
export namespace TRANSACTIONINFO {
    export type OperationEnum = 'DOWNLOAD_PROFILE' | 'GET_AUDIT' | 'ENABLE_PROFILE' | 'DISABLE_PROFILE' | 'DELETE_ISDP' | 'UPDATE_CONNECTIVITY' | 'SET_FALLBACK';
    export const OperationEnum = {
        DOWNLOADPROFILE: 'DOWNLOAD_PROFILE' as OperationEnum,
        GETAUDIT: 'GET_AUDIT' as OperationEnum,
        ENABLEPROFILE: 'ENABLE_PROFILE' as OperationEnum,
        DISABLEPROFILE: 'DISABLE_PROFILE' as OperationEnum,
        DELETEISDP: 'DELETE_ISDP' as OperationEnum,
        UPDATECONNECTIVITY: 'UPDATE_CONNECTIVITY' as OperationEnum,
        SETFALLBACK: 'SET_FALLBACK' as OperationEnum
    }
    export type StateEnum = 'SUCCESS' | 'FAILED' | 'EXPIRED' | 'IN_PROCESS' | 'ENQUEUED' | 'CANCELED';
    export const StateEnum = {
        SUCCESS: 'SUCCESS' as StateEnum,
        FAILED: 'FAILED' as StateEnum,
        EXPIRED: 'EXPIRED' as StateEnum,
        INPROCESS: 'IN_PROCESS' as StateEnum,
        ENQUEUED: 'ENQUEUED' as StateEnum,
        CANCELED: 'CANCELED' as StateEnum
    }
}



// WEBPACK FOOTER //
// ./src/gen/swagger-api/model/tRANSACTIONINFO.ts